import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { ADDRESS_BY_CHAIN_L2, getRelatedL2Chain } from '@cronos-app/sdk';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getVEthToken: TokenRegister = (desiredNetwork) => {
  return {
    type: Token.vETH,
    symbol: 'vETH',
    addressL1: '',
    addressL2: ADDRESS_BY_CHAIN_L2[getRelatedL2Chain(desiredNetwork)].ZkETH,
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/veth.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="vETH"
        {...props}
      />
    ),
  };
};
